function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTi24HourStandalone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.634,
    height: 57.857,
    viewBox: "0 0 55.634 57.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "h1v0ro463a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2499",
    style: {
      fill: "#f7a710"
    },
    d: "M0 0h55.634v57.857H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19990"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19675",
    style: {
      clipPath: "url(#h1v0ro463a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29194",
    d: "M17.762 0h.791a1.813 1.813 0 0 1 1.213 2.154H26.2A1.8 1.8 0 0 1 27.367 0h.9a1.816 1.816 0 0 1 1.176 2.172h6.437A1.823 1.823 0 0 1 37.086 0h.791a1.774 1.774 0 0 1 1.277 2.164h6.424A1.8 1.8 0 0 1 46.8 0h.8a1.8 1.8 0 0 1 1.23 2.211c.559 0 1.064-.019 1.566 0a7.454 7.454 0 0 1 1.51.152 4.793 4.793 0 0 1 3.725 4.941q.009 19.882-.01 39.764a1.14 1.14 0 0 1-.29.731q-4.852 4.901-9.745 9.751a1.137 1.137 0 0 1-.726.3q-19.883.022-39.764-.009a5.623 5.623 0 0 1-2.339-.5A4.781 4.781 0 0 1 0 52.612Q.014 30.046.007 7.48c0-.3.006-.6.034-.9a4.791 4.791 0 0 1 4.41-4.319c.775-.05 1.557-.008 2.383-.008A1.806 1.806 0 0 1 8.044 0h.791a1.813 1.813 0 0 1 1.242 2.175h6.4A1.8 1.8 0 0 1 17.762 0M2.663 8.857c-.011.214-.027.4-.027.581v43.22a2.276 2.276 0 0 0 2.541 2.555q19.294.006 38.588 0a.907.907 0 0 0 .994-1.007c.006-1.3-.027-2.6.02-3.9a3.419 3.419 0 0 1 3.243-3.3c1.3-.064 2.6-.03 3.9-.037.762 0 1.084-.325 1.084-1.088V9.44c0-.2-.017-.4-.026-.585z",
    style: {
      fill: "#f7a710"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29195",
    d: "M17.872 47.716h-3.894v-9.988h3.894a4.978 4.978 0 0 1 5.308 4.966v.028a5 5 0 0 1-5.308 4.994m3.011-4.994a2.868 2.868 0 0 0-3.011-3.01h-1.7v6.021h1.7a2.846 2.846 0 0 0 3.011-2.982z",
    transform: "translate(-.586 -1.583)",
    style: {
      fill: "#f7a710"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29196",
    d: "m32.27 47.712-.913-2.24h-4.223l-.913 2.24H23.98l4.281-10.058h2.026l4.281 10.058zm-3.025-7.419-1.327 3.239h2.654z",
    transform: "translate(-1.006 -1.58)",
    style: {
      fill: "#f7a710"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29197",
    d: "M39.959 43.735v3.981h-2.2v-3.938l-3.838-6.05h2.568l2.383 4.009 2.428-4.009h2.5z",
    transform: "translate(-1.423 -1.583)",
    style: {
      fill: "#f7a710"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29198",
    d: "M27.2 16.419h2.23v14.976H26.2V19.733l-2.591.637-.679-2.677z",
    transform: "translate(-.962 -.689)",
    style: {
      fill: "#f7a710"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTi24HourStandalone);
export default __webpack_public_path__ + "static/media/ti24HourStandalone.d3cb3598360e65f4a4745ec35f339dd1.svg";
export { ForwardRef as ReactComponent };